import type { WorkItemDto } from '@customTypes/types';

import { ManageEmployerView } from './ManageEmployerView';
import { useManageEmployerView } from './useManageEmployerView';

export const ManageEmployerContainer = ({
  workItem
}: {
  workItem: WorkItemDto;
}) => {
  const {
    functions: { sendLastWorkDate, confirmArrival, rejectWorkItem },
    isLoading
  } = useManageEmployerView({ workItem });
  return (
    <ManageEmployerView
      confirmArrival={confirmArrival}
      isLoading={isLoading}
      rejectWorkItem={rejectWorkItem}
      sendLastWorkDate={(newDate: string) => sendLastWorkDate(newDate)}
      workItem={workItem}
    />
  );
};
